import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`人生不如意十之八九，难得开心一二三。`}</p>
    <p>{`确定的和不确定的，喜欢的和不喜欢的， 开心的和难过的，悲喜交织。`}</p>
    <p>{`忆往昔少年意气，一袭青衫仗剑闯江湖。`}</p>
    <p>{`奈何江湖凶险，才入江湖，便出江湖。`}</p>
    <p>{`清晨醒来，元气满满，欲与天公试比高，立志要干翻这个世界。`}</p>
    <p>{`下班归来，拖着疲惫身躯躺在沙发上，面露颓色，被这个世界干的服服帖帖。`}</p>
    <p>{`生活是美好的，但不总是。`}</p>
    <p>{`俗话说，未来可期。但未知的事，是希望还是绝望，倒也真不好说。`}</p>
    <p>{`一件件小事积攒的委屈和绝望就像是一个火药桶，在爆炸边缘疯狂试探的火苗，不论多小，都有可能将其引爆。`}</p>
    <p>{`我们都在讲控制情绪，但所有事情真的都能控制住吗？显然并不是。`}</p>
    <p>{`选择的前提是，有可选项。`}</p>
    <p>{`情绪的控制也是，留有余地。`}</p>
    <p>{`渐渐地，我开始能理解那些或嚎啕大哭，或嘶吼呐喊，或轻生厌世的人背后的心酸了。`}</p>
    <p>{`打工人，摸摸头。`}</p>
    <p>{`不管未来可不可期，都不要轻言放弃。`}</p>
    <p>{`生死之外皆小事，活着才有翻盘的可能。`}</p>
    <p>{`上帝为你关上了一道门，你就打开一扇窗。`}</p>
    <p>{`如果上帝关上了你打开的那扇窗，也别慌，他并不是针对你，只是很单纯地不想让你出来。`}</p>
    <p>{`别急，挖个坑。把上帝一脚踹进去，埋了。`}</p>
    <p>{`安心走你的破局路，何人有权指指点点？`}</p>
    <p>{`信，他才是上帝。不信，小火慢炖加点盐。`}</p>
    <p>{`喜欢的才会捧在手心，不喜欢的，又算得上哪条酸菜鱼？`}</p>
    <p>{`最近一直很忙，大小周考驾照属实有些难搞，生活充满了苦涩。`}</p>
    <p>{`好在运气尚可，二次报考，皆是一次过，找回了曾失去的道心。`}</p>
    <p>{`心病唯有心药医，逃避换不来长久的心安。`}</p>
    <p>{`强烈建议，有考驾照想法的，在学校把驾照考完。等工作再考的话，即使是双休，周期也比较长，不太方便。别的地区咱也不熟，北京的话，如果你有考驾照的想法，并且选择海淀驾校，可以和邹国生教练聊聊。报名，学车，吹水皆可。联系方式，手机同微信，15110004663。`}</p>
    <p>{`一个有意思的人，教的不好你可以骂他。第一次乐呵呵回你，第二次大概就拿刀了吧，哈哈。`}</p>
    <p>{`混乱迷茫的日子里，邹教练的出现就是一道光，看似一缕，实则可抵万丈光芒。`}</p>
    <p>{`第一次觉得学车也能是一件有意思的事，或者说，学车加吹水。`}</p>
    <p>{`哈哈，这个我擅长。`}</p>
    <p>{`在此补充一下，我喜欢偶尔水别人的群，但不会自己建群。一是觉得比较忙，可能管不过来。二是懒，嗯，这是主要原因。`}</p>
    <p>{`所以，如果有什么想法，欢迎和我私聊。`}</p>
    <p>{`聊学习方法，聊技术，聊面试，都可。`}</p>
    <p>{`当然，如果你想要和我当同事，一起跳动，那更加是欢迎至极。`}</p>
    <p>{`努力内推的我比恋爱还认真，白白不胖，也要充满希望。`}</p>
    <p>{`可预见性的，以后的日子会更加充满色彩。`}</p>
    <p>{`小阿絮已经快四个月了，锁喉居然还抓我，攻击性渐长，缅因血脉觉醒。`}</p>
    <p>{`下班回来或自己做饭，或吃鲸鱼做好的，论有一个精致且厨艺好的室友的重要性。`}</p>
    <p>{`半年之久的等待，小婧也要来北京了，吃吃喝喝，玩玩乐乐。不管北漂能否容得下灵魂，能和有趣的灵魂一起漂，也是件乐事。`}</p>
    <p>{`大好时光，还有来日方长。`}</p>
    <p>{`接着奏乐接着舞，慢歌慢舞慢行舟。`}</p>
    <p>{`情如风雪无常,`}</p>
    <p>{`却是一动即殇。`}</p>
    <p>{`感谢你这么好看还来阅读我的文章,`}</p>
    <p>{`我是冷月心,下期再见。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      